import React from "react"
import { Navigate } from "react-router-dom"

//User Pages
import Users from "../pages/User/index"
import UserAddEdit from "../pages/User/UserAddEdit"
//Theme Pages
import Theme from "../pages/Theme/index"
//Subscription Pages
import Subscription from "../pages/Subscription/index"

//Report
import Report from "../pages/Report/index"
import ShowReport from "pages/Report/ShowReport"

//Notification Pages
import Notifications from "../pages/Notification/index"
import NotificationAddEdit from "../pages/Notification/NotificationAddEdit"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

//Center Profile Pages
import Profile from "../pages/Profile/index"
import Calender from "pages/Calendar/Calendar"

//Permission Pages
import RoleTypePermissions from "../pages/Permission/index"

import MyProfile from "pages/MyProfile/index"

//404 Page
import Pages404 from "../pages/Utility/404"
import ChangePasswordPage from "pages/Authentication/ChangePassword"
import DocumentPage from "pages/Document/Documents"

//Household Pages
import Households from "../pages/Household/index"
import HouseholdAddEdit from "pages/Household/HouseholdAddEdit"

//Bulk-Upload Pages
import BulkUpload from "../pages/BulkUpload/index"

//Subject Pages
import Subjects from "pages/Subject/index"
import SubjectAddEdit from "pages/Subject/SubjectAddEdit"

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  //Household
  { path: "/households", component: <Households /> },
  {
    path: "/household/:id",
    ParentMenu: "/households",
    component: <HouseholdAddEdit />,
  },

  //Subject
  { path: "/subjects", component: <Subjects /> },
  {
    path: "/subject/:id",
    ParentMenu: "/subjects",
    component: <SubjectAddEdit />,
  },

  //Bulk-Upload
  { path: "/bulk-upload", component: <BulkUpload /> },

  //User
  { path: "/users", component: <Users /> },
  { path: "/user/:id", ParentMenu: "/users", component: <UserAddEdit /> },

  //My Profile
  { path: "/profile", component: <MyProfile /> },

  //Notification
  { path: "/notifications", component: <Notifications /> },
  {
    path: "/notification/:id",
    ParentMenu: "/notifications",
    component: <NotificationAddEdit />,
  },

  // report
  { path: "/reports", component: <Report /> },
  { path: "/report/:id", ParentMenu: "/reports", component: <ShowReport /> },

  //Theme
  //{ path: "/settings/theme", component: <Theme /> },
  { path: "/settings/branding", component: <Theme /> },

  //Theme
  { path: "/settings/subscriptions", component: <Subscription /> },

  //document
  { path: "/documents", component: <DocumentPage /> },

  //Center Profile
  { path: "/settings/profile", component: <Profile /> },

  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },

  //calendar
  { path: "/calendar", component: <Calender /> },

  //permission
  { path: "/settings/permissions", component: <RoleTypePermissions /> },

  //change password
  { path: "/settings/changepassword", component: <ChangePasswordPage /> },

  //404 Page
  { path: "*", component: <Pages404 /> },
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
]

export { authProtectedRoutes, publicRoutes }
